const RELOAD_REASON_KEY = 'reload-tracker:reason'

export type ReloadReason =
  | 'user'
  | 'forced-app-version'
  | 'app-update'
  | 'service-worker'
  | 'network-reconnected'
  | 'error-boundary'
  | 'refresh-all-data'
  | 'realtime-load-cancelled'

/**
 * Use instead of window.location.reload() so PageReloaded events can distinguish
 * reloads triggered by the app from ones triggered by the user.
 */
export function reloadPage(reason: Exclude<ReloadReason, 'user'>) {
  try {
    sessionStorage.setItem(RELOAD_REASON_KEY, reason)
  } catch {
    // storage unavailable; the reload will be reported as 'user'
  }

  window.location.reload()
}

export function consumeReloadReason(): ReloadReason {
  try {
    const reason = sessionStorage.getItem(RELOAD_REASON_KEY) as ReloadReason | null
    sessionStorage.removeItem(RELOAD_REASON_KEY)

    return reason ?? 'user'
  } catch {
    return 'user'
  }
}
